import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const dismissOutstandingBalance = {
  name: "dismissOutstandingBalance" as const,
  input: z.object({
    returnId: zExt.objectId(),
    /** Also send the exchange at $0. Omitted means only void the invoice. */
    createExchangeOrder: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
